import { SidebarTrigger } from "@medme/ui"

/**
 * Header toggle button using shadcn SidebarTrigger.
 * Toggles sidebar visibility when clicked.
 */
export function HeaderToggle() {
	return <SidebarTrigger />
}
